import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import CareerListSection from "../../components/CareerSection/CareerListSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import TerminModal from "../../components/TerminModal/TerminModal";

const CareerPage = () => {
  const { t } = useTranslation();
  const [terminModalOpen, setTerminModalOpen] = useState(false);

  const openTerminModal = () => {
    setTerminModalOpen(true);
  };

  const closeTerminModal = () => {
    setTerminModalOpen(false);
  };

  return (
    <Fragment>
      <Navbar openTerminModal={openTerminModal} />
      <main className="page-offset career-page" aria-label={t("Career")}>
        <CareerListSection />
      </main>
      <Footer />
      <Scrollbar openTerminModal={openTerminModal} />
      <TerminModal open={terminModalOpen} onCloseModal={closeTerminModal} />
    </Fragment>
  );
};

export default CareerPage;
